import { render, staticRenderFns } from "./EnvioFacturas.vue?vue&type=template&id=2d672a8a&scoped=true&"
import script from "./EnvioFacturas.vue?vue&type=script&lang=js&"
export * from "./EnvioFacturas.vue?vue&type=script&lang=js&"
import style0 from "./EnvioFacturas.vue?vue&type=style&index=0&id=2d672a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d672a8a",
  null
  
)

export default component.exports